/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import { renderLanguageSelector } from "./renderLanguageSelector.js";

export function renderOrgLanguageSelector() {
  const color = "#2B91D6";
  const buttonStyle = {
    color: color,
  };

  const buttonBgStyle = {
    background: color,
  };

  return renderLanguageSelector(buttonBgStyle, buttonStyle);
}
